function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4232"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4232"] = parcelRequire;
}
parcelRequire.register("hI46L", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ce49bb81d6049457$export$6503ec6e8aabbaf; }, function (v) { return $ce49bb81d6049457$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ce49bb81d6049457$export$f7ad0328861e2f03; }, function (v) { return $ce49bb81d6049457$export$f7ad0328861e2f03 = v; });
var $ce49bb81d6049457$export$6503ec6e8aabbaf;
var $ce49bb81d6049457$export$f7ad0328861e2f03;
"use strict";
var $ce49bb81d6049457$var$mapping = {};
function $ce49bb81d6049457$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ce49bb81d6049457$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ce49bb81d6049457$var$resolve(id) {
    var resolved = $ce49bb81d6049457$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ce49bb81d6049457$export$6503ec6e8aabbaf = $ce49bb81d6049457$var$register;
$ce49bb81d6049457$export$f7ad0328861e2f03 = $ce49bb81d6049457$var$resolve;

});

var $d7730789739eb21c$exports = {};

(parcelRequire("hI46L")).register(JSON.parse('{"2lyl3":"index.0c7ade06.js","9Jo43":"phone-frame.b86bc4f5.svg","gCsL5":"app.c7a7d922.png","4nfgJ":"logo.2ea790a4.svg","2yL3M":"logo-rtl.1b37b5a5.svg","4gn5H":"import.b9b2940a.png","8by16":"shoppingList.6ccd81a4.png","cZErs":"steps.690d433f.png","4L2KN":"web-vitals.8ad11810.js"}'));


//# sourceMappingURL=index.5a4a7bab.js.map
